import { render, staticRenderFns } from "./MultiEditField.vue?vue&type=template&id=3609ffd6&"
import script from "./MultiEditField.vue?vue&type=script&lang=js&"
export * from "./MultiEditField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports